var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.847 18.753"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 11.768a.47.47 0 0 0-.469.469v4.168a1.41 1.41 0 0 1-1.408 1.408H2.347a1.41 1.41 0 0 1-1.408-1.408V4.173a1.41 1.41 0 0 1 1.408-1.408h4.168a.47.47 0 1 0 0-.939H2.347A2.35 2.35 0 0 0 0 4.173v12.232a2.35 2.35 0 0 0 2.347 2.349h13.171a2.35 2.35 0 0 0 2.347-2.347v-4.17a.47.47 0 0 0-.469-.469Zm0 0",
    "data-name": "Path 319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.679.618a2.11 2.11 0 0 0-2.987 0L6.318 8.992a.5.5 0 0 0-.12.207l-1.1 3.976a.469.469 0 0 0 .578.578l3.976-1.1a.5.5 0 0 0 .207-.12l8.374-8.375a2.115 2.115 0 0 0 0-2.987ZM7.34 9.298l6.854-6.859 2.21 2.21-6.854 6.854Zm-.442.886 1.766 1.766-2.443.677Zm10.667-6.691-.5.5-2.211-2.211.5-.5a1.173 1.173 0 0 1 1.659 0l.551.551a1.175 1.175 0 0 1 .002 1.66Zm0 0",
    "data-name": "Path 320"
  }))));
};
export default SvgEdit;